import { render, staticRenderFns } from "./LiveView.vue?vue&type=template&id=c70aa72e&scoped=true&"
import script from "./LiveView.vue?vue&type=script&lang=ts&"
export * from "./LiveView.vue?vue&type=script&lang=ts&"
import style0 from "./LiveView.vue?vue&type=style&index=0&id=c70aa72e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70aa72e",
  null
  
)

export default component.exports